import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import R from 'ramda'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import RatingsActions from '../../Data/Redux/RatingsRedux'
import Tool from '../../Components/ReportsComponents/Tool'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import LoadingSpinner from '../../Components/LoadingSpinner'
import { ReportHeader, ReportContainer, LoadingContainer, Export } from '../../Components/ReportsComponents'
import ReportTemplate from './ReportTemplate'


const COLORS = ['#152940', '#4B3F72', '#904C77', '#119DA4', '#53A2FF']

class MonthlyRatings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [{ id: 1, month: 'ENE', total: 0 }, { id: 2, month: 'FEB', total: 0 }, { id: 3, month: 'MAR', total: 0 }, { id: 4, month: 'ABR', total: 0 },
        { id: 5, month: 'MAY', total: 0 }, { id: 6, month: 'JUN', total: 0 }, { id: 7, month: 'JUL', total: 0 }, { id: 8, month: 'AGO', total: 0 },
        { id: 9, month: 'SEP', total: 0 }, { id: 10, month: 'OCT', total: 0 }, { id: 11, month: 'NOV', total: 0 }, { id: 12, month: 'DIC', total: 0 }],
    }
  }

  componentWillMount() {
    if (!this.props.fromCenter) {
      this.props.getRatings()
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const newState = { ...this.state }
    const { ratings, centers, centersInfo } = nextProps
    if (ratings && centers && !this.props.ratings) {
      for (let i = 1; i <= 12; i++) {
        if (ratings[i]) {
          for (let j = 1; j <= centers.length; j++) {
            if (ratings[i][j - 1]) {
              if (centers.length > 0) {
                let newTotal = 0
                const selectedCenter = centers.find(center => center.id === ratings[i][j - 1].center_id)
                newState.data[i - 1][selectedCenter.abbreviation] = ratings[i][j - 1].total
                newTotal = newState.data[i - 1]['total'] + parseFloat(ratings[i][j - 1].total)
                newState.data[i - 1]['total'] = newTotal
              }
            } else {
              for (let l = 1; l <= centers.length; l++) {
                if (!newState.data[i - 1][centers[l - 1].abbreviation]) {
                  newState.data[i - 1][centers[l - 1].abbreviation] = null
                }
              }
            }
          }
        } else {
          for (let j = 1; j <= centers.length; j++) {
            newState.data[i - 1][centers[j - 1].abbreviation] = null
          }
        }
        this.setState(newState)
      }
    }
    if (centersInfo && centers && !this.props.centersInfo) {
      for (let i = 1; i <= 12; i++) {
        if (centersInfo[i]) {
          for (let j = 1; j <= centers.length; j++) {
            if (centersInfo[i][j - 1]) {
              if (centers.length > 0) {
                let newTotal = 0
                const selectedCenter = centers.find(center => center.id === centersInfo[i][j - 1].center_id)
                newState.data[i - 1][selectedCenter.abbreviation] = centersInfo[i][j - 1].total
                newTotal = newState.data[i - 1]['total'] + parseFloat(centersInfo[i][j - 1].total)
                newState.data[i - 1]['total'] = newTotal
              }
            } else {
              for (let l = 1; l <= centers.length; l++) {
                if (!newState.data[i - 1][centers[l - 1].abbreviation]) {
                  newState.data[i - 1][centers[l - 1].abbreviation] = null
                }
              }
            }
          }
        } else {
          for (let j = 1; j <= centers.length; j++) {
            newState.data[i - 1][centers[j - 1].abbreviation] = null
          }
        }
        this.setState(newState)
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  getBars = () => {
    const bars = this.props.centers.map((value, index) => {
      return (
        <Bar key={index} dataKey={value.abbreviation} stackId="a" fill={this.pickColor(value.abbreviation) ? COLORS[index % COLORS.length] : 'gray'} />
      )
    })
    return bars
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  filter = (event) => {
    const newState = { ...this.state }
    const { ratings, centers } = this.props
    for (let i = 1; i <= 12; i++) {
      if (ratings[i]) {
        const selectedCenter = centers.find(center => center.abbreviation === event.currentTarget.id)
        const activeCenterIndex = R.findIndex(R.propEq('center_id', selectedCenter.id))(ratings[i])
        if (newState.data[i - 1][event.currentTarget.id] === '0' || newState.data[i - 1][event.currentTarget.id] === null) {
          if (ratings[i][activeCenterIndex]) {
            let newTotal = 0
            newState.data[i - 1][event.currentTarget.id] = ratings[i][activeCenterIndex].total
            newTotal = newState.data[i - 1]['total'] + parseFloat(ratings[i][activeCenterIndex].total)
            newState.data[i - 1]['total'] = newTotal
          }
        } else {
          let newTotal = 0
          newState.data[i - 1][event.currentTarget.id] = null
          newTotal = newState.data[i - 1]['total'] - parseFloat(ratings[i][activeCenterIndex].total)
          newState.data[i - 1]['total'] = newTotal
        }
      }
    }
    this.setState(newState)
  }

  pickColor = (name) => {
    let count = 0
    for (let i = 0; i < this.state.data.length; i++) {
      if (this.state.data[i][name] !== '0' && this.state.data[i][name] !== null) {
        count++
      }
    }
    return count > 0
  }

  render() {
    const { centers, fromCenter } = this.props
    const { width, data } = this.state
    return (
      <ReportTemplate
        title="Frecuencia de ratings: Mensual"
        date={data &&
          { initial: data[0].month, end: data[data.length - 1].month }}
        withOutExcel
        loading={!(centers.length > 0)}
      >
        {centers.length > 0 &&
          <BarChart
            width={width < 763 ? 400 : 648}
            height={width < 763 ? 300 : 400}
            data={data}
            margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip content={<Tool withoutCurrency large />} />
            <Legend content={<CustomizedLegend onClick={!fromCenter && this.filter} />} />
            {this.getBars()}
          </BarChart>
        }
      </ReportTemplate>
    )
  }
}


const mapStateToProps = ({ ratings, centerOptions, centersInfo }) => ({
  ratings: ratings.get.results.total_monthly_ratings,
  centers: centerOptions.get.results,
  centersInfo: centersInfo.ratings.results.total_monthly_ratings,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getRatings: () => dispatch(RatingsActions.getRequest({}, true)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MonthlyRatings))



// WEBPACK FOOTER //
// ./src/Containers/Reports/MonthlyRatings.jsx